export default function (breaks: unknown, nextBreakNumber: number, currentBlindNumber: number) {
  if (!breaks || !Array.isArray(breaks) || !breaks.length) {
    return false
  }
  if (nextBreakNumber >= breaks.length) {
    return false
  }
  const nextBreak: unknown = breaks[nextBreakNumber]
  return typeof nextBreak === 'object' && nextBreak !== null &&
    'afterLevelNumber' in nextBreak && nextBreak.afterLevelNumber === currentBlindNumber + 1
}